import type {OwnerId, ReviewAction, ReviewerRole, ReviewerRoleId} from "platformed-client/types";

/** Reviews keyed by owner — matches the shape on a `Reviewable`. */
export type ReviewMap = Record<OwnerId, ReviewAction>;

export type RoleGroup = {roleId: ReviewerRoleId; name: string; reviews: ReviewAction[]};

/**
 * Group reviews by role, preserving the configured role order. Reviewers without a
 * (known) role appear in no group; they are surfaced separately so they stay reachable.
 */
export function groupByRole(reviews: ReviewMap, roles: ReviewerRole[]): RoleGroup[] {
  const knownRoleIds = new Set(roles.map(r => r.reviewer_role_id));
  const byRole = new Map<ReviewerRoleId, ReviewAction[]>(roles.map(r => [r.reviewer_role_id, []]));
  for (const review of Object.values(reviews)) {
    if (review.reviewer_role_id && knownRoleIds.has(review.reviewer_role_id)) {
      byRole.get(review.reviewer_role_id)!.push(review);
    }
  }
  return roles.map(r => ({roleId: r.reviewer_role_id, name: r.name, reviews: byRole.get(r.reviewer_role_id)!}));
}
